import React from 'react'
import Icon from 'react-icon-base'

const CreateIcon = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g>
      <path d="m19.8 3.8c8.9 0 16.2 7.2 16.2 16.2s-7.3 16.3-16.2 16.3-16.3-7.3-16.3-16.3 7.3-16.2 16.3-16.2z m8.3 17.8v-3.2h-6.7v-6.8h-3.3v6.8h-6.7v3.2h6.7v6.8h3.3v-6.8h6.7z" />
    </g>
  </Icon>
)

export default CreateIcon
